import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/styles";
import DeleteCountyModal from "./delete.country.modal";
import EditCountryModal from "./edit.country.modal";
import { useNavigate, useParams } from "react-router-dom";
import { useStudyPlan } from "../../contexts/study.context";
import SectionHeader from "../section.header";
import { otherStyles } from "../../helpers/utils";
import OutlinedButton from "../buttons/outlined";
import SideBySide from "../sideBySide";

const CountryHeader = ({
  title,
  countryId,
  siteGroup,
  variant = "primary",
  hasDelete = true,
  hasEdit = true,
  studyPlanType,
  currentEffort,
  currentTimeframe,
  tab,
}) => {
  const navigate = useNavigate();
  const { id, planId } = useParams();
  const { canEditPlan } = useStudyPlan();
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const otherClasses = otherStyles();

  return (
    <>
      <SideBySide>
        <SectionHeader
          paddingBottom={false}
          marginBottom={false}
        >
          {title}
        </SectionHeader>
        <div style={{ display: "flex" }}>
          {canEditPlan && hasEdit === false && (
            <OutlinedButton
              style={{ marginBlock: "0.7em", marginInline: "1em" }}
              onClick={() =>
                navigate(
                  `/ctpo/study-plans/${id}/${planId}/countries-and-site-groups#country-inputs`,
                  { tabIndex: tab },
                )
              }
            >
              <EditIcon style={{ marginRight: ".3em" }} /> Edit
            </OutlinedButton>
          )}
          {hasEdit && (
            <IconButton
              disableRipple
              style={{ marginBlock: "0.25em", marginRight: "0.2em" }}
              className={otherClasses.iconButton}
              onClick={() => setOpenEdit(true)}
            >
              <EditIcon className={otherClasses.iconButton} />
            </IconButton>
          )}
          {hasDelete && (
            <IconButton
              disableRipple
              style={{ marginBlock: "0.25em", marginRight: "0.4em" }}
              className={otherClasses.iconButton}
              onClick={() => setOpen(true)}
            >
              <DeleteIcon className={otherClasses.iconButton} />
            </IconButton>
          )}
        </div>
      </SideBySide>
      {hasDelete && (
        <DeleteCountyModal
          countryId={countryId}
          siteGroup={siteGroup}
          open={open}
          onClose={() => setOpen(false)}
        />
      )}

      {hasEdit && openEdit && (
        <EditCountryModal
          countryId={countryId}
          siteGroup={siteGroup}
          studyPlanType={studyPlanType}
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          currentEffort={currentEffort}
          currentTimeframe={currentTimeframe}
        />
      )}
    </>
  );
};

export default CountryHeader;

const useStyles = makeStyles((theme) => ({
  root: {
    color: "var(--teal-700)",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "var(--teal-100)",
      transition: "background-color 0.2s ease",
    },
    "&:active": {
      backgroundColor: "var(--teal-300)",
    },
    "&:focus": {
      outline: "1px solid var(--teal-500)",
      outlineOffset: "4px",
    },
    "&:disabled": {
      opacity: 0.6,
    },
  },
}));
